import { isNil } from 'lodash'

import CowmedChip from '#/components/Chip'

const TypeCollarTag = ({ value }) => {
  if (isNil(value?.status)) return '-'

  const levelMap = {
    inbound: 'success',
    outbound: 'info',
  }

  const { status, text } = value ?? {}
  const level = levelMap[status]

  return <CowmedChip level={level} value={text} tooltip={text} variant="soft" />
}

export { TypeCollarTag }
